import axios, {AxiosInstance, AxiosResponse} from 'axios';

export default class CurrencyApi {

    getCurrencyList(baseCurrency: string, pairs: string[]): Promise<{[k:string]: number}> {
        const promises: Array<Promise<{[k:string]: number}>> = [];
        pairs.forEach(pair => {
            promises.push(axios.get(`https://api.frankfurter.app/latest?from=${baseCurrency}&to=${pair}`).then((response) => {
                const obj: {[k:string]: number} = {};
                obj[pair] = response.data.rates[pair];
                return obj;
            }));
        });

        return Promise.all(promises).then(values => {
            const currencyList: {[k:string]: number} = {};
            values.forEach(item => {
                Object.keys(item).forEach(k => {
                    currencyList[k] = item[k];
                })
            });
            return currencyList;
        })

    }
}
